module.exports = __webpack_public_path__ + "static/media/curator-id.95e97c22.jpg";